import { useMediaQuery } from '@mui/material'
import { useState } from 'react'

import {
  type ColorMode,
  initialColorMode,
  storeColorMode
} from '@/utils/colorMode'

export interface ColorModeControl {
  mode: ColorMode
  toggleMode: () => void
}

/**
 * Current colour mode plus a toggle, persisted across reloads.
 *
 * A single boolean does not warrant a store — root CLAUDE.md puts this kind of
 * state in hooks. (untool-mage uses zustand for the same job because it manages
 * far more client state.)
 */
export function useColorMode(): ColorModeControl {
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)')
  // Seeded once: after first render the submitter's own choice governs, so a
  // change to the OS setting must not yank the mode out from under them.
  const [mode, setMode] = useState<ColorMode>(() =>
    initialColorMode(prefersDark, globalThis.localStorage ?? null))

  const toggleMode = (): void => {
    setMode((current) => {
      const next: ColorMode = current === 'light' ? 'dark' : 'light'
      storeColorMode(next, globalThis.localStorage ?? null)
      return next
    })
  }

  return { mode, toggleMode }
}
